export enum Role {
  ServiceStation = 10,
  CaseManager = 20,
  CompanyAdmin = 30,
}
